const Icons = () => {
	return (
		<ul className="flex flex-row items-center justify-center gap-3 content-center  ">
			<li><img className="w-10 h-10" src="https://www.vectorlogo.zone/logos/reactjs/reactjs-icon.svg" alt="" /></li>
			<span>+</span>
			<li><img className="w-10 h-10" src="https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg" alt="" /></li>
			<span>+</span>
			<li><a title="Google LLCSVG by CoreyVidal, Public domain, via Wikimedia Commons" href="https://commons.wikimedia.org/wiki/File:Google_Keep_icon_(2015-2020).svg"><img className="w-10 h-10" alt="Google Keep icon (2015-2020)" src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/Google_Keep_icon_%282015-2020%29.svg/512px-Google_Keep_icon_%282015-2020%29.svg.png" /></a></li>
			<span>+</span>
			<li><img className="w-10 h-10" src="https://www.vectorlogo.zone/logos/mongodb/mongodb-icon.svg" alt="" /></li>
		</ul>
	)
}
export default Icons